import Vue from "vue";

//
// Router
// ------
//
import Router from "vue-router";
Vue.use(Router);
import Home from "../views/Home"; //主页
import ConfirmOrder from "../views/ConfirmOrder"; //确认订单
import Login from "../views/Login"; //登录
import StaySubmitOrder from "../views/StaySubmitOrder"; //待进场订单
import ParkingDuration from "../views/ParkingDuration"; //请选择停车时长
import ProvinceList from "../views/ProvinceList"; //省份简称

//公共的
import Time from "../views/public/Time"; //停车时长
import Charge from "../views/public/charge"; //充电页面
import ChargeStop from "../views/public/chargeStop"; //充电停止码页面
import ChargeHelp from "../views/public/chargeHelp"; //充电帮助页面
import ChargeInfo from "../views/public/chargeInfo"; //充电信息页面
import ChargeDetail from "../views/public/chargeDetail"; //充电详情页面
import complaint from "../views/public/complaint"; //我要投诉
import OvertimeRules from "../views/public/overtimeRules"; //超时计费标准
import InvoiceExplain from "../views/public/InvoiceExplain"; //开票说明
import userTreaty from "../views/public/userTreaty"; //用户协议
//支付
import OvertimeOrder from "../views/payment/OvertimeOrder"; //超时待支付
import ExcessOrder from "../views/payment/ExcessOrder"; //超时待支付
//用户帮助
import UserCenter from "../views/user/userCenter"; //用户中心
import Policy from "../views/user/policy"; //用户中心
import UserHelp from "../views/user/userHelp"; //用户帮助
import Ruler from "../views/user/ruler"; //扣费规则
import AutoParkingIUseRule from "../views/user/autoParkingIUseRule"; //无人值守使用规则
import VehicleLicenseAuth from "../views/user/vehicleLicenseAuth"; //车辆认证页面
//用户中心
import personalData from "../views/user/personalData"; //个人资料
import changeMobile from "../views/user/changeMobile"; //请输入原手机号，然后获取验证码更改手机号
import changeCarId from "../views/user/changeCarId"; //更改车牌号
//发票
import invoicing from "../views/invoice/invoicing"; //发票
import invoicingList from "../views/invoice/invoicingList"; //发票列表
import historyInvoicing from "../views/invoice/historyInvoicing"; //发票历史
import invoicingInfo from "../views/invoice/invoicingInfo"; //开票详情
import invoiceCompletion from "../views/invoice/invoiceCompletion"; //电子发票成功页面
import invoiceDetails from "../views/invoice/invoiceDetails"; //发票详情
import orderInvoicingList from "../views/invoice/orderInvoicingList"; //发票详情里面查询相关订单
//订单
import OrderList from "../views/order/OrderList"; //订单列表
import OrderDetails from "../views/order/OrderDetails"; //订单详情
import SubmitOrder from "../views/SubmitOrder"; //订单提交成功
//vip
import BindingVip from "../views/vip/BindingVip"; //绑定Vip
import VipInfo from "../views/vip/VipInfo"; //Vip详情
//地址
import AddressList from "../views/address/AddressList"; //地址列表
import OverTimeRuleClause from "../views/public/overTimeRuleClause"; //超时费用规则
import CommonProblem from "../views/public/CommonProblem"; //常见问题
import LeaveVoucher from "../views/LeaveVoucher"; //离场凭证
import GotoLeaveVoucher from "../views/GotoLeaveVoucher"; //获取离场凭证


import bmwRule from "../views/bmwRule"; // 宝马超时规则
import roadbook from "../views/roadbook";
import wxchome from "../views/WxcHome";


const router = new Router({
  routes: [
    {
      path: "/",
      name: "home",
      component: Home,
      meta: {
        keepAlive: true, //此组件需要被缓存
        otherBack: false //非指定页返回
      }
    },
    {
      path: "/confirmOrder/:id/:latitude/:longitude/:placeEmpty/:chargeType/:hasDisperser",
      name: "confirmOrder",
      component: ConfirmOrder,
      meta: {
        keepAlive: true, //此组件需要被缓存
        otherBack: false //非指定页返回
      }
    },
    {
      path: "/login",
      name: "login",
      component: Login
    },
    {
      path: "/submitOrder/:orderId",
      name: "submitOrder",
      component: SubmitOrder
    },
    {
      path: "/staySubmitOrder/:orderId/:type",
      name: "staySubmitOrder",
      component: StaySubmitOrder
    },
    {
      path: "/orderList/:orderIds",
      name: "orderList",
      component: OrderList
    },
    {
      path: "/orderDetails/:orderId",
      name: "orderDetails",
      component: OrderDetails
    },
    {
      path: "/overtimeOrder/:orderId",
      name: "overtimeOrder",
      component: OvertimeOrder
    },
    {
      path: "/ExcessOrder/:orderId",
      name: "ExcessOrder",
      component: ExcessOrder
    },
    {
      path: "/parkingDuration/:parkingId",
      name: "parkingDuration",
      component: ParkingDuration
    },
    {
      path: "/ProvinceList",
      name: "ProvinceList",
      component: ProvinceList
    },
    {
      path: "/userCenter",
      name: "UserCenter",
      component: UserCenter
    },
    {
      path: "/userHelp",
      name: "UserHelp",
      component: UserHelp
    },
    {
      path: "/ruler",
      name: "Ruler",
      component: Ruler
    },
    {
      path: "/autoParkingIUseRule",
      name: "AutoParkingIUseRule",
      component: AutoParkingIUseRule
    },
    {
      path: "/vehicleLicenseAuth",
      name: "VehicleLicenseAuth",
      component: VehicleLicenseAuth
    },
    {
      path: "/Time/:orderId",
      component: Time
    },
    {
      path: "/charge/:orderId",
      component: Charge
    },
    {
      path: "/chargeStop/:identCode",
      component: ChargeStop
    },
    {
      path: "/chargeHelp",
      component: ChargeHelp
    },
    {
      path: "/chargeInfo/:orderId",
      component: ChargeInfo
    },
    {
      path: "/chargeDetail/:orderId/:chargeSeq",
      component: ChargeDetail
    },
    {
      path: "/userTreaty",
      component: userTreaty
    },
    {
      path: "/invoicing",
      name: "invoicing",
      component: invoicing
    },
    {
      path: "/invoicingList",
      name: "invoicingList",
      component: invoicingList
    },
    {
      path: "/historyInvoicing",
      name: "historyInvoicing",
      component: historyInvoicing
    },
    {
      path: "/invoicingInfo/:orderId/:orderAmount",
      // path: "/invoicingInfo/:orderId/:orderAmount/:parkingName/:companyName/:companyId/:parkingId",
      name: "invoicingInfo",
      component: invoicingInfo
    },
    {
      path: "/invoiceCompletion",
      name: "invoiceCompletion",
      component: invoiceCompletion
    },
    {
      path: "/invoiceDetails/:id",
      name: "invoiceDetails",
      component: invoiceDetails
    },
    {
      path: "/personalData",
      name: "personalData",
      component: personalData
    },
    {
      path: "/changeMobile",
      name: "changeMobile",
      component: changeMobile
    },
    {
      path: "/changeCarId",
      name: "changeCarId",
      component: changeCarId,
      meta: {
        keepAlive: true,
        otherBack: false
      }
    },
    {
      path: "/complaint/:orderId",
      name: "complaint",
      component: complaint
    },
    {
      path: "/orderInvoicingList/:orderIds",
      name: "orderInvoicingList",
      component: orderInvoicingList
    },
    {
      path: "/bindingVip",
      name: "bindingVip",
      component: BindingVip
    },
    {
      path: "/vipInfo",
      name: "vipInfo",
      component: VipInfo
    },
    {
      path: "/overtimeRules",
      name: "overtimeRules",
      component: OvertimeRules
    },
    {
      path: "/invoiceExplain",
      name: "invoiceExplain",
      component: InvoiceExplain
    },
    {
      path: "/addressList",
      name: "addressList",
      component: AddressList
    },
    {
      path: "/overTimeRuleClause",
      name: "overTimeRuleClause",
      component: OverTimeRuleClause
    },
    {
      path: "/commonProblem",
      name: "commonProblem",
      component: CommonProblem
    },
    {
      path: "/leaveVoucher/:orderId",
      name: "leaveVoucher",
      component: LeaveVoucher
    },
    {
      path: "/gotoLeaveVoucher/:orderId",
      name: "gotoLeaveVoucher",
      component: GotoLeaveVoucher
    },
    {
      path: "/policy",
      name: "policy",
      component: Policy
    },
    {
      path: "/bmwRule",
      name: "bmwRule",
      component: bmwRule
    },
    {
      path: "/roadbook/:parkingId",
      name: "roadbook",
      component: roadbook
    },
    {
      path: "/noticeDetail",
      name: "noticeDetail",
      component: () => import('@/views/noticeDetail')
    },
	{
		path: "/channelHome",
		name: "wxchome",
		component: wxchome
	}
  ]
});

export default router;
